<template>
  <router-link :to="block.path" class="product-card">
    <div class="product-card__image">
      <img :src="block.src"/>
    </div>
    <div class="product-card__description">
      <h3>{{ block.title}}</h3>
      <p>{{ block.description }}</p>
    </div>
  </router-link>
</template>
<script>
const name = 'ProductCard'

const props = {
  block: {
    type: Object,
    default: () => { return {} }
  }
}

function data() {
  return {
    loaded: false
  }
}

function created() {
  this.preloadImage()
}

function preloadImage() {
  const inst = this

  let image = new Image();
  image.onload = function() {
    inst.loaded = true
  }
  image.src = inst.block.src
}

export default {
  name,
  props,
  data,
  created,
  methods: {
  	preloadImage
  }
}

</script>
